import { Button } from "@mantine/core";
import { type SubmitHandler, useForm } from "react-hook-form";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import { FormFieldController } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import type { VermarktungContractTemplateAdjustments } from "../Direktvermarktung.types";
import { useDirektvermarktungContracts } from "../hooks/useDirektvermarktungContracts";
import { VERMARKTUNG_CONTRACT_TEMPLATE_ADJUSTMENT_FIELDS } from "./VermarktungContractTemplateAdjustment.constants";

interface VermarktungContractTemplateAdjustmentProps {
  onConfirm: SubmitHandler<VermarktungContractTemplateAdjustments>;
  onCancel: () => void;
}

function VermarktungContractTemplateAdjustment({
  onConfirm,
  onCancel
}: VermarktungContractTemplateAdjustmentProps) {
  const { control, handleSubmit } =
    useForm<VermarktungContractTemplateAdjustments>();

  const { data: contracts, isLoading: isLoadingContracts } =
    useDirektvermarktungContracts({ variantId: null });

  const contractOptions =
    contracts?.map((contract) => ({
      value: contract.id,
      label: contract.name
    })) ?? [];

  return (
    <form onSubmit={handleSubmit(onConfirm)}>
      <FormFieldController
        control={control}
        data={{
          ...VERMARKTUNG_CONTRACT_TEMPLATE_ADJUSTMENT_FIELDS.copyId,
          loading: isLoadingContracts,
          data: contractOptions
        }}
      />
      <ModalFooter justify="space-between">
        <Button variant="default" onClick={() => onCancel()}>
          Abbrechen
        </Button>
        <Button type="submit">Weiter</Button>
      </ModalFooter>
    </form>
  );
}

export { VermarktungContractTemplateAdjustment };
